import { QueryKey } from '@/configs/queryKeys';
import { SerializedCreator } from '@/types/creator';
import { UUID } from '@/types/types';
import { ProductType } from './ProductTypeApi';
import { Order } from './OrderApi';
import { AttributeValue } from './AttributeValueApi';
import { Accessory } from './AccessoryApi';
import { QueryFunctionContext } from '@tanstack/react-query';
import { Fabric } from './FabricApi';
import EntityApi, { BaseEntity } from './EntityApi';
import httpClient from './httpClient';

export interface ProductPrices {
	price: number;
	discountedPrice: number;
}

export interface ProductAccessory extends BaseEntity {
	product?: Product;
	productId: UUID;
	accessory?: Accessory;
	accessoryId: UUID;
	quantity: number;
}

export interface Product extends BaseEntity, ProductPrices {
	order?: Order;
	orderId: UUID;
	width: number;
	height: number;
	heightInputMode: string;
	widthInputMode: string;
	quantity: number;
	productType?: ProductType;
	productTypeId: UUID;
	comment: string;
	attributeValues?: AttributeValue[];
	attributeValuesIds: UUID[];
	productAccessories: ProductAccessory[];
	fabric: Fabric | null;
	serializedCreator: SerializedCreator;
}

export interface CalculatePricePayload {
	productTypeId: UUID;
	width: number;
	height: number;
	productAccessories: {
		accessoryId: string;
		quantity: number;
	}[];
	fabricId?: UUID;
	attributeValuesIds: UUID[];
}

class ProductApi extends EntityApi<Product> {
	constructor() {
		super(QueryKey.products);
		this.copy = this.copy.bind(this);
	}

	async calculatePrice({
		queryKey,
	}: QueryFunctionContext<[QueryKey, CalculatePricePayload]>) {
		const response = await httpClient.post<ProductPrices>(
			`${queryKey[0]}/calculate-price`,
			queryKey[1]
		);

		return response.data;
	}

	async copy(id: UUID) {
		const response = await httpClient.post<Product>(
			`${this.queryKey}/${id}/copy`
		);

		return response.data;
	}
}

export default new ProductApi();
